<template>
  <va-edit-layout :actions="['list', 'show', 'delete']">
    <water-supply-form :id="id" :title="title" :item="item"></water-supply-form>
  </va-edit-layout>
</template>

<script>
export default {
  props: ['id', 'title', 'item'],
}
</script>
